import type { StockListItem, StockWithAnalysis } from '@stock-dashboard/shared';

const API_BASE_URL = import.meta.env.VITE_API_URL || '';

interface ApiResponse<T> {
  success: boolean;
  data?: T;
  error?: string;
  meta?: {
    total?: number;
  };
}

export async function fetchStocks(): Promise<StockListItem[]> {
  const response = await fetch(`${API_BASE_URL}/api/stocks`);
  const data: ApiResponse<StockListItem[]> = await response.json();
  
  if (!data.success) {
    throw new Error(data.error || 'Failed to fetch stocks');
  }
  
  return data.data || [];
}

export async function fetchStockByTicker(ticker: string): Promise<StockWithAnalysis> {
  const response = await fetch(`${API_BASE_URL}/api/stocks/${ticker}`);
  const data: ApiResponse<StockWithAnalysis> = await response.json();
  
  if (!data.success) {
    throw new Error(data.error || 'Failed to fetch stock');
  }
  
  if (!data.data) {
    throw new Error('Stock not found');
  }
  
  return data.data;
}

export async function fetchStocksBySector(sector: string): Promise<StockListItem[]> {
  const response = await fetch(`${API_BASE_URL}/api/stocks/sector/${sector}`);
  const data: ApiResponse<StockListItem[]> = await response.json();
  
  if (!data.success) {
    throw new Error(data.error || 'Failed to fetch stocks by sector');
  }
  
  return data.data || [];
}
